// extracted by mini-css-extract-plugin
module.exports = {"SectionU1":"SectionU1_SectionU1__TzN5r"};